
import { Vue, Component } from 'vue-property-decorator';
import Banner from '@/components/Banner.vue';
import VoteList from '../components/SyVoteList.vue';
import PickerInput from '../components/PickerInput.vue';
import SearchInput from '../components/SearchInput.vue';
import { getMajorList, getCollegeList } from '../api/index';
@Component({
  name: 'CollegeWork',
  components: {
    Banner,
    VoteList,
    PickerInput,
    SearchInput,
  },
})
export default class CollegeDetail extends Vue {
  collegeData: any = {};
  majorList: any[] = [];
  sortBy = 'vote-list-rand';
  selectMajor = '';
  searchData = '';
  tempSearchData = '';

  get params() {
    return this.$route.query;
  }

  created() {
    this.fetchMajorList();
    const data = sessionStorage.getItem('CM-CollegeList');
    if (data) {
      const temp: any = JSON.parse(data);
      console.log(3332, temp);
      this.collegeData = temp.filter((item: any, index: number) => {
        return item.id === this.params.id;
      })[0];
      console.log(111, this.collegeData);
    }
  }

  async fetchMajorList() {
    const ret = await getMajorList(this.params.id as string);
    this.majorList = ret.data.map((item: any) => item.title);
  }
  jumpDetail(item: any) {
    this.$router.push({
      path: 'WorkDetail',
      query: {
        id: item.id as string,
      },
    });
  }
  handleSearchData(e: any) {
    this.tempSearchData = e;
    console.log(e);
  }
  handleStartSearch() {
    console.log('start search!');
    // this.selectMajor = '';
    this.searchData = this.tempSearchData;
  }
  handClickSortBy() {
    this.sortBy = this.sortBy === 'vote-list' ? 'vote-list-rand' : 'vote-list';
  }
  pickerData(e: any) {
    console.log(e);
    this.selectMajor = e;
  }
  // 跳转院校详情
  toCollegeDetail() {
    window.location.href = this.collegeData.video;
    // this.$router.push({
    //   path: 'CollegeDetail',
    //   query: this.params,
    // });
  }
  // 返回
  backRoute() {
    if (window.history.length <= 1) {
      this.$router.push('index');
    } else {
      this.$router.go(-1);
    }
  }
}
